import { ResultDiagramLabelQuestion } from './result-diagram-label-question.store';

export const ResultFlowChartComplexQuestion = ResultDiagramLabelQuestion.named(
  'ResultFlowChartComplex'
);
